import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { Role } from '@shared/types';

interface RoleState {
  role: Role;
  userId: string | null;
  branchId: string;
  setRole: (role: Role) => void;
  setUser: (userId: string, role: Role, branchId: string) => void;
  loginAsClient: (clientId: string) => void;
  logout: () => void;
}

export const useRoleStore = create<RoleState>()((set) => ({
  role: 'Officer',
  userId: null,
  branchId: 'b1',
  setRole: (role) => set({
    role,
    branchId: role === 'Admin' ? 'Global' : 'b1'
  }),
  setUser: (userId, role, branchId) => set({ userId, role, branchId }),
  loginAsClient: (clientId) => set({
    role: 'Client',
    userId: clientId,
    branchId: 'b1'
  }),
  logout: () => {
    useBranchStore.getState().setSelectedBranch('all');
    set({ role: 'Officer', userId: null, branchId: 'b1' });
  },
}));

interface BranchState {
  selectedBranchId: string;
  setSelectedBranch: (id: string) => void;
}
export const useBranchStore = create<BranchState>()(
  persist(
    (set) => ({
      selectedBranchId: 'all',
      setSelectedBranch: (id) => set({ selectedBranchId: id }),
    }),
    {
      name: 'perfect-match-branch-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

interface FontSizeState {
  fontSize: 'small' | 'medium' | 'large';
  setFontSize: (size: FontSizeState['fontSize']) => void;
}
export const useFontSizeStore = create<FontSizeState>()(
  persist(
    (set) => ({
      fontSize: 'medium',
      setFontSize: (size) => set({ fontSize: size }),
    }),
    {
      name: 'perfect-match-font-size-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
